import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';
import { cardHover, fadeUp, stagger, viewport } from '../motion';

const Education = () => {
  const educationDetails = [
    {
      institution: "Oriental Institute of Science and Technology Indore",
      degree: "Bachelor of Technology (B-Tech)",
      field: "Computer Science and Engineering",
      score: "CGPA: 8.7 / 10",
      year: "Graduation Year: 2024",
      icon: (
        <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
        </svg>
      )
    },
    {
      institution: "Govt. Excellence School Athner",
      degree: "Higher Secondary School",
      field: "Stream: Mathematics & Science",
      score: "Passing Year: 2020",
      year: "Board: MP State Board",
      icon: (
        <svg className="w-6 h-6 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
        </svg>
      )
    }
  ];

  return (
    <section id="education" className="py-20 relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-20 left-10 w-40 h-40 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob-slow"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob-medium"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <SectionHeading eyebrow="Academics" title="Education" className="mb-16" />

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-8"
          variants={stagger(0.15)}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
        >
          {educationDetails.map((edu, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 transition-shadow duration-500 flex flex-col justify-between h-full relative overflow-hidden hover:shadow-2xl"
              variants={fadeUp}
              whileHover={cardHover}
            >
              {/* Top Accent Bar */}
              <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-blue-600 to-indigo-700"></div>

              <div>
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0">
                    {edu.icon}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 font-sans leading-tight">
                    {edu.institution}
                  </h3>
                </div>

                <div className="space-y-3 pl-16">
                  <p className="text-lg font-semibold text-blue-700 font-sans">{edu.degree}</p>
                  <p className="text-gray-600 text-sm font-sans">{edu.field}</p>
                  <p className="text-gray-500 text-sm font-sans font-medium">{edu.year}</p>
                  
                  <div className="inline-block mt-2 px-4 py-1.5 bg-indigo-50 text-indigo-700 text-sm font-bold rounded-full border border-indigo-100 font-sans">
                    {edu.score}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Education;
